// A question to a connected agent about a whole subject: a pull request,
// asked from the conversation's composer or a passage of the description
// (components/RelayThread.svelte, `about`), or a branch's history, from
// its page (components/SubjectAsk.svelte). It travels as a subject task
// (api/relayTask.ts, `changeling.review-subject.v1`), with no lines; the
// review skill (plugins/changeling/skills/review/SKILL.md) says how an
// agent reads one.
import { pullKey, type SubjectKey } from '../api/relaySubject';
import { SUBJECT_TASK, type TaskBody } from '../api/relayTask';

/** What a question about the pull request carries: which it is and its head, the request, and the passage of the description it is about, if any. */
export function prTask(
  pr: { owner: string; repo: string; number: number; headRefOid: string | null },
  instruction: string,
  quote: string | null = null,
): TaskBody {
  const head = pr.headRefOid;
  if (!head) throw new Error('This pull request has not loaded yet. Try again in a moment.');
  return subjectTask(pullKey(pr.owner, pr.repo, pr.number), head, instruction, quote);
}

/**
 * What a question about a whole subject carries (a pull request's, or a
 * branch's history asked about from its page): which it is and the head it
 * was asked at, the request, and a quoted passage, if any.
 */
export function subjectTask(subject: SubjectKey, head: string, instruction: string, quote: string | null = null): TaskBody {
  return { kind: SUBJECT_TASK, payload: { subject, head, instruction, ...(quote ? { quote } : {}) } };
}
